// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__18ig9","label":"Radio_label__3-Y1E","checkMark":"Radio_checkMark__1MNai","disabled":"Radio_disabled__d5YUG"};